import { de, enUS, es, fr, hu, nl, ptBR, it, sv } from 'date-fns/locale'

const locales = { de, en: enUS, es, fr, hu, nl, ptBR, it, sv }

export default locales
